/**
 * Custom cart count helper that excludes free items and samples
 * This function filters cart items to exclude:
 * - Hidden items (seo.hidden metafield set to "1")
 * - Items with 'sample' in the product title (case-insensitive)
 */
function getCustomCartCount(cartData) {
  if (!cartData || !cartData.items) {
    return 0;
  }
  
  return cartData.items.reduce((total, item) => {
    const isSample = item.product_title && item.product_title.toLowerCase().includes('sample');
    const isHidden = item.product && item.product.metafields && item.product.metafields.seo && item.product.metafields.seo.hidden === 1;
    
    // Only count quantities of items that are not samples or hidden
    if (!isSample && !isHidden) {
      return total + (item.quantity || 1);
    }
    return total;
  }, 0);
}

// Function to update all cart count elements in the DOM
function updateAllCartCountElements(customCount) {
  // Update all cart count number elements
  document.querySelectorAll('[data-cart-count-number]').forEach(el => {
    el.textContent = customCount < 100 ? customCount : '99+';
  });
  
  // Update cart count text for screen readers
  document.querySelectorAll('[data-cart-count-text]').forEach(el => {
    const countText = customCount === 1 ? '1 item' : `${customCount} items`;
    el.textContent = countText;
  });
  
  // Update cart empty state
  document.querySelectorAll('[data-cart-count-bubble]').forEach(el => {
    el.classList.toggle('is-cart-empty', customCount === 0);
  });
}

// Listen for cart update events and apply custom count
function handleCartUpdate() {
  // Use requestAnimationFrame to ensure this runs after the native update
  requestAnimationFrame(() => {
    if (window.FoxThemeCartHelpers && window.FoxThemeCartHelpers.getState) {
      window.FoxThemeCartHelpers.getState().then(cartData => {
        const customCount = getCustomCartCount(cartData);
         updateAllCartCountElements(customCount);
      });
    }
  });
}

// Prevent multiple subscriptions by checking if already subscribed
if (window.FoxThemeEvents && !window.customCartCountSubscribed) {
  window.customCartCountSubscribed = true;
  window.FoxThemeEvents.subscribe('cart-update', handleCartUpdate);
}

// Make functions globally available
window.getCustomCartCount = getCustomCartCount;
window.updateAllCartCountElements = updateAllCartCountElements;
